import { useLang } from "@/i18n/LangContext";

const Marquee = () => {
  const { content } = useLang();
  const MARQUEE_ITEMS = content.marquee;
  return (
  <div
    data-testid="marquee-ribbon"
    className="relative border-y border-[#F4F1EA]/10 bg-[#111113] py-5 overflow-hidden"
  >
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="marquee-group" aria-hidden={copy === 1}>
          {MARQUEE_ITEMS.map((item, i) => (
            <span key={i} className="flex items-center gap-14">
              <span className="font-display italic text-lg text-[#D8D4C8] whitespace-nowrap">
                {item}
              </span>
              <span className="text-[#D4AF37] text-xs">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
  );
};

export default Marquee;
